export default {
  locale: state => state.currentLocale,
  locales: state => state.locales,
  homeUrl: state => "/".concat(state.currentLocale.market, "/").concat(state.currentLocale.language),
  serviceNumber: state => state.serviceNumber
};